import { Column } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import type { Loan, LoanType } from 'app/types/loan';
import { useTranslation } from 'react-i18next';

interface ScreenContentProps {
  isLoading: boolean;
  isRefetching: boolean;
  loanType: LoanType;
  loans: Loan[];
  onRefresh: () => void;
  tPrefix: string;
}

export function ScreenHeading({ loanType, tPrefix }: Pick<ScreenContentProps, 'loanType' | 'tPrefix'>) {
  const { t } = useTranslation('loans');

  return (
    <Column alignItems="center">
      <Text fontWeight="600" marginBottom="spacing.general.x2" textAlign="center" variant="headerXSmall">
        {t(`${tPrefix}${loanType}.title`)}
      </Text>
      <Text color="text.secondary" textAlign="center">
        {t(`${tPrefix}${loanType}.subtitle`)}
      </Text>
    </Column>
  );
}
